import { render } from "./NotesIconSlider.vue?vue&type=template&id=d3c10a08"
import script from "./NotesIconSlider.vue?vue&type=script&lang=js"
export * from "./NotesIconSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__